import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'

const Container = styled.footer`
	padding: 25px 1rem;
`

const Flex = styled.div`
  display: flex;
  align-items: center;
  flex:1;
`

const FooterLink = styled(Link)`
	color: #222;
	margin-right: 25px;
`

export default () => (
	<Container>
		<Flex>
			<FooterLink to="/sitemap">Sitemap</FooterLink>
			<FooterLink to="/about">About</FooterLink>
			<FooterLink to="/contact">Contact</FooterLink>
		</Flex>
	</Container>
)